import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { IIndividuals } from "./models";
import { individualItems } from "./individual.mock";
import { memo, useCallback, useState } from "react";
import { Individual } from "./IndividualForm/Individual";

const translationPath = "page.4uDlist.generationRule.individual.";

export const IndividualPage = memo(() => {
  const [individual, setIndividual] = useState(false);

  const [selectedId, setSelectedId] = useState<string>();

  const { t } = useTranslation();

  const { id } = useParams();

  const columns: GridColDef<IIndividuals>[] = [
    {
      field: "sex",
      headerName: t(translationPath + "sex") || "Sex",
      renderCell: (params) => {
        if (!params.value) return "-";
        return (
          <OverflowTooltip
            text={params.value.name}
            tooltip={params.value.name}
            textTransform="none"
            variant="body2"
          />
        );
      },
    },
    {
      field: "age",
      headerName: t(translationPath + "age") || "Age",
      renderCell: (params) => {
        if (!params.value) return "-";
        return (
          <OverflowTooltip
            text={params.value.name}
            tooltip={params.value.name}
            textTransform="none"
            variant="body2"
          />
        );
      },
    },
  ];

  const handleAdd = () => {
    setIndividual(true);
  };

  const handleRowClick = (params: GridRowParams<IIndividuals>) => {
    if (!params.row) return;
    setIndividual(true);
    setSelectedId(params.row.id);
  };

  const handleBack = useCallback(() => {
    setSelectedId(undefined);
    setIndividual(false);
  }, []);

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {individual && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <Individual id={selectedId} onBackButton={handleBack} />
        </Box>
      )}
      {!individual && (
        <Box height={600}>
          <Table<IIndividuals>
            showDefaultMacroFilters={false}
            rows={individualItems}
            columns={columns}
            title={t(translationPath + "individuals")}
            searchInput
            onAdd={handleAdd}
            onRowClick={handleRowClick}
            searchInputPlaceHolder={t(translationPath + "search")}
            addButtonLabel={
              t(translationPath + "add_individual") || "Add Individual"
            }
            confirmOptions={{
              title: t(translationPath + "confirm.title"),
              description: t(translationPath + "confirm.description"),
              confirmationButtonProps: {
                variant: "contained",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
});
